import { useCallback, useEffect, useState } from 'react'
import api from '../../utils/apiClient'

export default function useSavedSearches() {
	const [saved, setSaved] = useState([])
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState(null)

	const refresh = useCallback(async () => {
		setLoading(true)
		setError(null)
		try {
			const res = await api.get('/api/saved-searches')
			setSaved(res.data?.data || [])
		} catch (err) {
			console.error('[useSavedSearches] list failed:', err)
			setError(err)
		} finally {
			setLoading(false)
		}
	}, [])

	useEffect(() => {
		refresh()
	}, [refresh])

	const addSaved = useCallback(async filters => {
		try {
			const res = await api.post('/api/saved-searches', { filters })
			const created = res.data?.data
			if (created) setSaved(prev => [created, ...prev])
			return { ok: true }
		} catch (err) {
			console.error('[useSavedSearches] create failed:', err)
			setError(err)
			const message =
				err?.response?.data?.message || 'Could not save this search.'
			return { ok: false, message }
		}
	}, [])

	const removeSaved = useCallback(async id => {
		let removed = null
		setSaved(prev => {
			removed = prev.find(s => s.id === id) || null
			return prev.filter(s => s.id !== id)
		})
		try {
			await api.delete(`/api/saved-searches/${id}`)
		} catch (err) {
			console.error('[useSavedSearches] delete failed:', err)
			if (removed) {
				setSaved(prev => (prev.some(s => s.id === id) ? prev : [removed, ...prev]))
			}
			setError(err)
		}
	}, [])

	return {
		saved,
		loading,
		error,
		addSaved,
		removeSaved,
		refresh,
	}
}
